import SettingsContainer from './settings_container'

export default SettingsContainer
